module.exports = __webpack_public_path__ + "media/application/images/icons/icon-business-practices-51c06e96ef3302bffb737f4792a8680a.svg";